
import React, { useState, useMemo } from "react";
import DataTable from "components/DataTable";
import PageWrapper from "components/PageWrapper";
import { useTableData } from "../../hooks/useTableData";
import { walletReportsConfig } from "../../config/tableConfigs";
import { useSession } from "hooks/useSession";

const WalletReportsPage = () => {
  const {userid, role} = useSession();
  const userRole = role === "Platform User" ? "Admin" : role;
  // Default API URL (without hardcoded invalid dates)
   const getLast7Days = () => {
    const today = new Date();
    const last7 = new Date();
    last7.setDate(today.getDate() - 1)  ;
  
    return {
      start: last7.toISOString().split("T")[0],
      end: today.toISOString().split("T")[0],
    };
  };
  
const getTodayRange = () => {
  const now    = new Date();
  const offset = now.getTimezoneOffset(); // minutes behind UTC
  const local  = new Date(now.getTime() - offset * 60 * 1000);
  const today  = local.toISOString().split("T")[0];
  return { start: today, end: today };
};

const { start, end } = getTodayRange();
  
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  
  const [apiUrl, setApiUrl] = useState(
    `https://pro.mokshiq.in/main_wallet_report?user=${userid}&filter_date=${start}&end_date=${end}`
  );

  // Example: set this dynamically after login if needed
 

  const tableData = useTableData(apiUrl, walletReportsConfig);

  // Called by PageWrapper when date range changes
  const handleDateFilter = (startDate, endDate) => {
    console.log("Date Filter Applied:", startDate, "→", endDate);
    const newUrl = `https://pro.mokshiq.in/main_wallet_report?user=${userid}&filter_date=${startDate}&end_date=${endDate}`;
    setApiUrl(newUrl);
  };

  // === Role-based column filtering ===
  const filteredConfig = useMemo(() => {
    const baseConfig = { ...walletReportsConfig };

    const roleColumnMap = {
      "Retailer": [
        "id",
        "order_id",
        "product",
        "amount",
        "status",
        "type",
        "opening_balance",
        "closing_balance",
        "commission",
        "tds",
        "charge",
        "created_at",
      ],
      "API Partner": [
        "id",
        "order_id",
        "product",
        "amount",
        "status",
        "type",
        "opening_balance",
        "closing_balance",
        "commission",
        "tds",
        "charge",
        "created_at",
      ],
      "White label": [
    "ID",
    "created_at",
    "BC Name",
    "Product",
    "Amount",
    "Status",
    "Opening Balance BC",
    "BC Commission",
    "BC TDS",
    "BC Charge",
    "Closing Balance BC",
    "Customer No",
    "TXN Flow",
    "REF No",
    "ACK NO",
    "TXN Date",
    "TXN Time"
  ],
      "Distributer": [
        "id",
        "order_id",
        "product",
        "amount",
        "status",
        "type",
        "commission",
        "tds",
        "charge",
        "created_at",
      ],
     "Admin": [
  "ID",
  "created_at",
  "modified_at",
  "BC Name",
  "Product Type",
  "Product",
  "Amount",
  "Commission",
  "TDS",
  "Charge",
  "Opening Balance",
  "Closing balance",          // ⚠️ lowercase 'b'
  "SDOpening Balance",
  "SDCommission",
  "SDTDS",
  "SDCharge",
  "SDClosing balance",        // ⚠️ lowercase 'b'
  "DOpening Balance",
  "DCommission",
  "DTDS",
  "DCharge",
  "DClosing balance",         // ⚠️ lowercase 'b'
  "Opening Balance BC",
  "BC Commission",
  "BC TDS",
  "BC Charge",
  "Closing Balance BC",       // ✅ uppercase 'B'
  "Customer No",
  "Status",
  "Wallet Txn",
  "TXN Flow",
  "REF No",
  "ACK NO",
  "TXN ID",
  "bank_rrn",
  "aadhar_number",
  "TXN Date",
  "TXN Time",
],
     "Main Admin": [
  "id",
  "modified_at",
  "BC_ID",
  "BC Name",
  "Transection Type",
  "Product",

  "Opening Balance MAdmin",
  "Amount",
  "Commission",
  "Charge",
  "TDS",
  "Closing balance MAdmin",

  "Opening Balance Admin",
  "ACommission",
  "ATDS",
  "ACharge",
  "AGST",
  "Closing Balance Admin",

  "Opening Balance BC",
  "BC Commission",
  "BC TDS",
  "BC Charge",
  "Closing Balance BC",

  "Customer No",
  "Status",
  "Wallet Txn",
  "TXN Flow",
  "REF No",
  "ACK NO",
  "bank_rrn",
  "aadhar_number",
  "created_at",
  "TXN Date",
  "TXN Time",
  "TXN ID",
  "Admin"
]

    };

    const allowed = roleColumnMap[userRole] || [];
    baseConfig.columns = walletReportsConfig.columns.filter((col) =>
      allowed.includes(col.key)
    );

    return baseConfig;
  }, [userRole]);

  // === Table action handlers ===
  const handleView = (report) => {
    console.log("Viewing report:", report);
  };

  const handleEdit = (report) => {
    console.log("Editing report:", report);
  };

  const handleDelete = (report) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      console.log("Deleting report:", report);
    }
  };

  const handleExport = (selectedIds) => {
    console.log("Exporting selected data:", selectedIds);
    alert(`Exporting ${selectedIds.length} selected records`);
  };

  const handleDeleteSelected = (selectedIds) => {
    if (
      window.confirm(`Are you sure you want to delete ${selectedIds.length} records?`)
    ) {
      console.log("Deleting selected records:", selectedIds);
    }
  };

  return (
    <PageWrapper config={walletReportsConfig} onDateFilter={handleDateFilter}>
      <DataTable
        config={filteredConfig}
        tableData={tableData}
        onView={handleView}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onExport={handleExport}
        onDeleteSelected={handleDeleteSelected}
      />
    </PageWrapper>
  );
};

export default WalletReportsPage;
